import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccessTokenInterceptor, AppOAuthStorageService } from '@y42/auth';
import { AUTH_ROUTES } from '@y42/auth/feature';
import { OAuthStorage } from 'angular-oauth2-oidc';

@NgModule({
  imports: [RouterModule.forChild(AUTH_ROUTES)],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccessTokenInterceptor,
      multi: true,
    },
    {
      provide: OAuthStorage,
      deps: [AppOAuthStorageService],
      useFactory: (oauthStorage: AppOAuthStorageService) => oauthStorage,
    },
  ],
})
export class AuthModule {}
